/* eslint-disable */
import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { FormattedMessage } from "react-intl";
import { Typography, ExpansionPanel, AccordionSummary, AccordionDetails, SvgIcon } from "@material-ui/core";
import { ArrowDropUp, ArrowDropDown } from "@material-ui/icons";

import { calendarPanel } from "../constants/types";
import { styles } from "../constants/styles";

type OwnProps = {
  item: calendarPanel;
  collapsedPanels: Set<string>;
  setCollapsedPanels: (collapsedPanels: Set<string>) => void;
};

type Props = OwnProps & WithStyles<typeof styles>;

const UpdatesCalendar: React.FC<Props> = (props: Props) => {
  const { item, classes, collapsedPanels, setCollapsedPanels } = props;

  const setExpansionState = (event: any, expanded: boolean) => {
    const newSet = new Set(collapsedPanels);
    if (expanded) {
      newSet.delete(item.id);
    } else {
      newSet.add(item.id);
    }
    setCollapsedPanels(newSet);
  };

  return (
    <ExpansionPanel
      onChange={setExpansionState}
      classes={{ root: classes.expansionPanelRoot, expanded: classes.expansionPanelRootExpanded }}
      key={item.id}
      expanded={!collapsedPanels.has(item.id)}
    >
      <AccordionSummary classes={{ root: classes.expansionPanelHeader }}>
        <SvgIcon className={classes.expansionPanelIcon}>
          {!collapsedPanels.has(item.id) ? <ArrowDropUp /> : <ArrowDropDown />}
        </SvgIcon>
        <div className={classes.expansionPanelTitleContainer}>
          <Typography className={classes.expansionPanelTitleTypo}>
            <FormattedMessage {...item.title} />
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.expansionPanel}>
        {item.cards.map((card) => (
          <div key={card.id} className={classes.calendarCardRoot}>
            <div className={classes.calendarCardLeftSide}>
              <Typography className={classes.calendarCardPlainTypo}>
                <FormattedMessage {...card.title} />
              </Typography>
            </div>
            <div className={classes.calendarCardRightSide}>
              {card.contentItems.map((content) => (
                <Typography key={content.id} className={classes.calendarCardPlainTypo}>
                  <FormattedMessage {...content} />
                </Typography>
              ))}
            </div>
          </div>
        ))}
      </AccordionDetails>
    </ExpansionPanel>
  );
};

export default withStyles(styles)(UpdatesCalendar);
